import './style.css'

function Media(props) {
    return (
        <a href={props.href}><img src={props.src} alt={props.alt} className='ico'/></a>
    )
}

export default Media